import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

export default function Login({ setNavChange }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  // const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "Babz" && password === "babz") {
      history.push("/Home");
      setNavChange((prevState) => ({
        ...prevState,
        navbar: true,
        navbarText: username,
      }));
    } else {
      alert("Please check usename and password");
    }
  };

  return (
    <div>
      <div className="login">
        <div className="container">
          <div
            id="login-row"
            className="row justify-content-center align-items-center"
          >
            <div id="login-column" className="col-md-6">
              <div id="login-box" className="col-md-12">
                <form onSubmit={handleSubmit} method="post">
                  <h3 className="text-center text-red">
                    <b>Login</b>
                  </h3>
                  <div className="form-group">
                    <label className="text-red">UserName</label>
                    <input
                      type="text"
                      name="username"
                      value={username}
                      className="form-control"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="text-red">Password</label>
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {/* {error === true ? (
                    <h6 className="">Enter Valid username and password</h6>
                  ) : null} */}
                  <div className="form-group mt-4 ">
                    <input
                      type="submit"
                      name="Submit"
                      className="btn btn-md"
                      value="Submit"
                    />
                  </div>
                </form>
                <h5>Username = "Babz" , Password = "babz" </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
